// import { toastStore } from '../toast/toastStore';
import { useEffect, useState } from "react";
import { AsyncOperationProps, asyncOperation } from "../utils/asyncOperation";

/**
 * Utility that performs an async operation with a message to the user, and also sets the busy flag.
 *
 * If `onError` is not defined, this method will throw an exception.
 *
 * If `onSuccess` is defined, `onSuccess` is called with the result.
 */
type Props<T> = Omit<AsyncOperationProps<T>, "setBusyFlag" | "onSuccess">;
export const useAsyncState = <T>(args: Props<T>) => {
  //
  const [value, setValue] = useState<T | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>();

  useEffect(() => {
    asyncOperation({
      ...args,
      setBusyFlag: setIsLoading,
      onSuccess: (value) => {
        setValue(value);
      },
    });
  }, []);

  return { value, isLoading };
};
